import { render, staticRenderFns } from "./ActiveStatusConfirmationPopup.vue?vue&type=template&id=6d72308b&lang=pug&"
import script from "./ActiveStatusConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./ActiveStatusConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ActiveStatusConfirmationPopup.vue?vue&type=style&index=0&id=6d72308b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports